import { pulseAxiosInstance } from "@pulse/api/axiosInstance";

export const sendInvitation = async ({
    surveyId,
}: {
    surveyId: number;
}): Promise<{ failed: string[] }> =>
    (await pulseAxiosInstance.post(`survey-email/send-invitation`, { surveyId })).data;

export const sendReminder = async ({
    surveyId,
}: {
    surveyId: number;
}): Promise<{ failed: number }> =>
    (await pulseAxiosInstance.post(`survey-email/send-reminder`, { surveyId })).data;
